import { ICellRendererParams } from 'ag-grid-community'
import { FloatingEditableIcon } from '../../containers/commons/AgGrid/components/cell/common/text'
import { ProjectPlanCumulation } from '../../../lib/functions/projectPlan'
import formatter from '../../containers/meta/formatter'
import { RootDiv } from '../../containers/commons/AgGrid/components/cell/CellRendererRoot'

export default function CellRenderer(params: ICellRendererParams) {
  const { data, colDef, value, valueFormatted } = params
  if (!data || data.total || !colDef) {
    return true
  }
  let renderValue = valueFormatted || value
  const cumulation: ProjectPlanCumulation = data.cumulation
  const formatWorkload = (value: number | undefined) =>
    formatter.format(
      Number(
        (value || 0) /
          (params.context.workloadUnitState?.hoursPerSelectedUnit || 1)
      ),
      params.colDef!.cellRendererParams.uiMeta
    )
  if (
    data.wbsItem.wbsItemType.isTask() &&
    cumulation &&
    (!!cumulation.countStatusTaskTodo ||
      !!cumulation.countStatusTaskDoing ||
      !!cumulation.countStatusTaskReview ||
      !!cumulation.countStatusTaskDone)
  ) {
    // Show aggregate on parent task row
    renderValue = `${renderValue} / ${formatWorkload(
      Number(data.wbsItem.estimatedWorkload?.hour || 0) +
        cumulation.sumTaskEstimatedHour -
        cumulation.sumTaskEstimatedHourDiscard
    )}`
  }

  return (
    <RootDiv>
      {renderValue}
      <FloatingEditableIcon {...params} />
    </RootDiv>
  )
}
